import { PERMISSIONS } from '../../constants';
import edit from './PopUpEdit';

export default {
  list: edit,
  name: 'pop-ups',
  permissions: [PERMISSIONS.POP_UPS],
};
